import { NgModule } from '@angular/core';
import { NavbarComponent } from './navbar.component';
import { GiantSharedModule } from '../../shared/GiantSharedModule';
import { NavbarVerticalStyle1Module } from './vertical/vertical.module';



@NgModule({
    declarations: [
        NavbarComponent
    ],
    imports     : [
        GiantSharedModule,
        NavbarVerticalStyle1Module,
    ],
    exports     : [
        NavbarComponent
    ]
})
export class NavbarModule
{
}
